import styled from 'styled-components'

export default styled.div`
  padding: 10px;

  background: #F5F8F9;
  border-bottom: 1px solid #E7EAEE;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/Header.js